const Guides: React.FC = () => {
  return (
    <div className="featured-topics-page-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132; Guides
      </p>
      <h2 className="help-heading">Guides</h2>
      <p>
        <a href="/guides/basics" className="getting-started-title">
          Getting started basics
        </a>
      </p>
      <p>
        <a href="/guides/level2" className="getting-started-title">
          Level 2 trading guide
        </a>
      </p>
      <p>
        <a href="/guides/paper" className="getting-started-title">
          Paper trading guide
        </a>
      </p>
      <p>
        <a href="/guides/moderation" className="getting-started-title">
          Moderation Policies
        </a>
      </p>
    </div>
  );
};

export default Guides;
